import React from 'react';
import {fetchUtils, SelectInput, Button, TabbedForm, FormTab, Filter, required, Toolbar, SaveButton, 
	DateField, Edit, Create, List, Datagrid, TextField, TextInput, DateInput, SelectArrayInput, FormDataConsumer,
	ReferenceArrayInput, AutocompleteArrayInput } from 'react-admin';
import DataTable from 'react-data-table-component';
import CloudDownload from '@material-ui/icons/CloudDownload';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import DeleteWithConfirmation from './components/DeleteWithConfirmation.js';

const utils = require('./components/utils.js');
const dataSupport = require('./components/data_support.js');

const fetch = fetchUtils.fetchJson;
const BASE_URL = window.nobid_endpoint + '/missing_sites_report';

const choicesType = [
	{ id: 'video', name: 'Video' },
	{ id: 'banner', name: 'Banner' },
	{ id: 'site', name: 'Site' },
	{ id: 'app', name: 'App' }
];
const choicesInterval = [
	{ id: 'hour', name: 'Hourly' },
	{ id: 'day', name: 'Daily' },
	{ id: 'week', name: 'Weekly' },
	{ id: 'month', name: 'Monthly' }
];
const dateRangeChoices = [
	{ id: 0, name: 'Today' },
	{ id: 1, name: 'Yesterday' },
	{ id: 2, name: 'Last 2 Days' },
	{ id: 3, name: 'Last 3 Days' },
	{ id: 7, name: 'Last 7 Days' },
	{ id: 8, name: 'Last 8 Days' },
	{ id: 10, name: 'Last 10 Days' },
	{ id: 30, name: 'Last 30 Days' },
	{ id: 'lm', name: 'Last Month' },
  { id: 'mtd', name: 'Month to Date' },
  { id: 'mty', name: 'Month to Yesterday' },
	{ id: 'custom', name: 'Custom' }
];
const choicesShow = [
	{ id: 'date', name: 'Date' },
	{ id: 'publisher', name: 'Publisher' },
	{ id: 'tldomain', name: 'Domain/App' },
	{ id: 'type', name: 'Type'}
];
const MissingSitesTitle = ({ record }) => {
	return <span>Missing Sites Report {record ? `"${record.name}"` : ''}</span>;
};
const MissingSitesFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="search_name" alwaysOn resettable />
    </Filter>
);
export const MissingSitesList = (props) => (
	<List {...props} title="Missing Sites Reports" perPage={25} bulkActionButtons={false} filters={<MissingSitesFilter />} 
	exporter={false} >
		<Datagrid rowClick="edit">
			<TextField source="name" label="Name" />
			<DateField source="updated_at" label="Update Date" />
			<DateField source="created_at" label="Creation Date" />
			<DeleteWithConfirmation {...props}/>
		</Datagrid>
	</List>
);
class CustomToolbar extends React.Component {
	state = {
	}
	constructor(props) {
		super(props);
		this.parent = props.parent;
	}
	fetchData() {
		let show='';
		if (formData.show) formData.show.map(item => { show+='&show='+item; });
		let interval = (formData.interval) ? `&interval=${formData.interval}` : '&interval=day';
		let dateRange = '';
		if ('custom'===formData.date_range) {
			dateRange = `&start_date=${formData.start_date}&end_date=${formData.end_date}`;
		} else {
			dateRange = `&date_range=${formData.date_range}`;
		}

		this.parent.setState({loading: true, total: '---'});
		let url = `${BASE_URL}?r=1${show}${interval}${dateRange}`+
		`${utils.formDataFieldsQueryStringFormat(formData, ['publisher_id', 'tldomain', 'type'])}`;
		let options = { headers: new Headers() };
		options.headers.set('accept', 'application/json');
		const token = localStorage.getItem('token');
		options.headers.set('Authorization', `Bearer ${token}`);
		fetch(url, options).then(({ headers, json }) => (
			this.parent.setState({data: json.data, loading: false, total: json.total})
		));
	}
	handleSearch = (props) => {
		this.fetchData();
	}
	render() {
		return <Toolbar>
			<SaveButton style={{marginRight: '10px'}} variant='contained' 
				color='primary' disabled={this.props.parent.state.loading} {...this.props}/>
			<br />
			<Button label='Run Report' onClick={this.handleSearch} props={this} variant='contained' color='primary' 
				startIcon={<RunReportIcon />} style={{padding: '7px', width: '160px'}} 
				disabled={this.props.parent.state.loading} />
			<br />
			<DateField source="updated_at" label="Update date" style={{ padding: '10px' }} showTime />
			<TextField source="updated_name" label="" style={{ padding: '10px' }} />
		</Toolbar>
	}
};
let formData = {};
function setFormData(formdata) {
	formData = formdata;
}
class MissingSitesForm extends React.Component {
	state = {};
	render() {
		return (
			<TabbedForm toolbar={<CustomToolbar parent={this.props.parent} />} redirect='edit' {...this.props}>
			<FormTab label="Report Settings">
				<TextInput source="name" label="Report Name" style={{ width: '400px' }} validate={required()} />
				<FormDataConsumer>
					{({ formData }) => setFormData(formData) }
				</FormDataConsumer>
				<div style={{ width: '100%', overflow: 'hidden' }}>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Interval" source="interval"
						choices={choicesInterval}
						defaultValue='day'
						disabled={this.props.parent.loading} />
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectInput label="Date Range" source="date_range"
						choices={dateRangeChoices}
						onChange={value => this.setState({ date_range: value.target.value })}
						defaultValue="0"
						disabled={this.props.parent.loading} />

						<div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
						<div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="Start Date" source="start_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>

						<div style={{ float: 'left', display: ('custom' !== this.state.date_range) ? 'none' : 'block' }}>
							<DateInput label="End Date" source="end_date" allowEmpty
							disabled={this.props.parent.loading}
							style={{ display: ('custom' !== this.state.date_range) ? 'none' : 'block' }} />
						</div>
						</div>
					</div>
					<div style={{ float: 'left', paddingRight: '5px' }}>
						<SelectArrayInput label="Show"
						source="show"
						choices={choicesShow}
						defaultValue={['date', 'publisher', 'tldomain']}
						style={{ width: '400px' }}
						disabled={this.props.parent.loading} />
					</div>
				</div>
				<div style={{ width: '100%', overflow: 'hidden' }} id="wrapper3">
					
					<div style={{ float: 'left', paddingRight: '5px' }}>
					<ReferenceArrayInput 
						source="publisher_id" 
						label="Publishers" 
						reference="publishers"
						basePath="publishers"
						perPage={15} 
						sort={{ field: 'name', order: 'ASC' }}
						filterToQuery={searchText => ({ search_name: searchText })}
						allowEmpty
						disabled={this.props.parent.loading}>
						<AutocompleteArrayInput disabled={this.props.parent.loading} label="Publishers" optionText="name" optionValue="code"/>
					</ReferenceArrayInput>
					</div>

					<div style={{ float: 'left', paddingRight: '10px' }}>
					<TextInput source="tldomain" label="Domain / App" style={{ width: '400px' }} />
					</div>

					<div style={{ float: 'left', paddingRight: '5px' }}>
					<SelectArrayInput label="Type" 
					source="type" 
					choices={choicesType} 
					style={{ width: '150px' }}
					disabled={this.props.parent.loading} />
					</div>
				</div>
			</FormTab>
			</TabbedForm>
		)
	}
}
let BASE_COLUMNS = [
	{ name: 'Date', selector: 'date', sortable: true, cell: row => ('' + row.date) },
	{ name: 'Publisher', selector: 'publisher_name', sortable: true, cell: row => <span>{ `${row.publisher_name} (${row.publisher_id})` }</span> },
	{ name: 'Site', selector: 'site_name', sortable: true, cell: row => <span>{ `${row.site_name} (${row.site_id})` }</span> },
	{ name: 'Type', selector: 'type', sortable: true, cell: row => <span>{ `${row.type?row.type.toUpperCase():'NA'}` }</span> },
	{ name: 'Domain/App', selector: 'tldomain', sortable: true },
	{ name: 'Requests', selector: 'requests', sortable: true, cell: row => utils.formatLong(row.requests) }
];
let columns = [];
const conditionalRowStyles = [
	{   
			when: row => (row.response_rate <= 5 || row.fill_rate <= 0),
			style: {color: 'red', backgroundColor: 'white'}
	},
	{   
		when: row => (row.response_rate >= 10  && row.fill_rate >= 0.5),
			style: {color: 'green', backgroundColor: 'white'}
	},
];
class MissingSitesUpsert extends React.Component {
	state = {
		data: [],
		loading: false,
		total: '---'
	};
	setState(obj) {
		if (obj.data && obj.data.length>0) {
			let keys = Object.keys(obj.data[0]);
			columns = BASE_COLUMNS.filter( item => { return keys.includes(item.selector) } );
		}
		super.setState(obj);
	}
	render(props) {
		const { data, loading, total } = this.state;
		return (
		<div>
			{this.props.formType === "edit" &&
				<Edit title={<MissingSitesTitle />} {...this.props}>
					<MissingSitesForm formType="edit" parent={this}/>
				</Edit>
			}
			{this.props.formType === "create" &&
				<Create title="Create Missing Sites Report" {...this.props}>
					<MissingSitesForm formType="create" parent={this}/>
				</Create>
			}
			<DataTable
				title={`${total} Matching Results`}
				theme={window.nobid_table_theme()}
				columns={columns}
				data={data}
				progressPending={loading}
				pagination
				fixedHeader
				dense
				conditionalRowStyles={conditionalRowStyles}
				paginationPerPage={30}
				paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
				subHeader={!loading}
				subHeaderComponent={
					(
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<input type="text" id='search_box' label="Search"
						variant="outlined"
						style={{ margin: '5px' }}
						onChange={(target) => dataSupport.filterData(this)} />
						<CloudDownload
						label="Export"
						style={{ margin: '5px' }}
						color="action"
						onClick={() => dataSupport.exportData(this.state.data)}
						/>
					</div>
					)
				}
			/>
			<div style={{fontSize: '12px', textAlign: 'right'}}>Data is approximated and is not exact.</div>
		</div>
		)
	}
}

export const MissingSitesEdit = (props) => (
	<MissingSitesUpsert formType="edit" {...props} />
);

export const MissingSitesCreate = (props) => (
	<MissingSitesUpsert formType="create" {...props} />
);